var _ = require('underscore');
var $ = require('jquery');
var Authorization = require('Authorization');
var Behaviors = require('Behaviors');
var Entities = require('Entities');
var Marionette = require('marionette');
var DialogWarning = require('DialogWarning');
var Dropdown = require('Dropdown');
var UserLookup = require('UserLookup');
var Validation = require('validation');
var DateTimeUtil = require('DateTimeUtil');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var Roles = new Entities.Roles(Resources.Roles);
var Offset = 100; // A sufficient offset between approver-groups to ensure that there's room to add approvers at each level.

var ranks = function (approver, enumeration) {
    var shift = enumeration.get(approver.get('rank')).get('order');

    return enumeration.filter(function (item) {
        return item.get('order') >= shift;
    });
};

var View = Marionette.View.extend({

    behaviors: [{ behaviorClass: Authorization.RBAC, viewName: 'recordApprover' }, Behaviors.PrintCheckbox],
    className: function () { return !this.model.get('givenName') ? 'hidden-print' : ''; },
    events: {
        'click @ui.plus': 'add',
        'click @ui.minus': 'remove',
        'click @ui.clearRank': 'clearRank'
    },
    initialize: function () {
        Validation.bind(this);
    },
    modelEvents: {
        'change:order': function () { this.collection.sort(); }
    },
    clearRank: function() {
        this.model.set('rank', undefined);
        this.$el.find('select')[0].selectedIndex = 0;
        this.$el.find('#rank').removeClass('required');
        this.$el.find('.required-errmsg').addClass('hidden');
    },
    regions: {
        rank: '#rank',
        user: '#user'
    },
    template: '#recordApprover',
    ui: {
        approval: '#approval',
        acknowledgedate: '#acknowledgedate',
        comment: '#comment',
        group: '#group',
        minus: '#minus',
        plus: '#plus',
        printComment: '#printComment',
        rank: '#rankContainer',
        rankLabel: '#rankLabel',
        recusal: '#recusal',
        recusalText: '#recusalText',
        independence: '#independence',
        approverBox: '.approver-box',
        clearRank: '#clearRank',
        requiredAA:'#required-AA'
    },
    onRender: function () {
        var groups = this.options.groups;
        var record = this.options.record;
        var complete = record.get('statusTypeId') === Lookups.StatusType.Complete;
        var model = this.model;
        var order = record.get('statusTypeId') === Lookups.StatusType.ReviewApproval ? groups.get(record.get('approverGroupId')).get('order') : -1;
        var group = groups.get(model.get('approverGroupId'));
        var first = model === this.collection.findWhere({ approverGroupId: group.id });
        var me = (record.get('assignedTo') !== '' && (model.get('upn') === record.get('assignedTo'))) && model.get('approverGroupId') === record.get('approverGroupId');
        var disable = (me || model.get('approval') || (!model.get('approval') && order > group.get('order')));
        var getApproverGroupId = this.model.get('approverGroupId');
        var isRecordNotified = (record.get('recordTypeId') === 'RecordType_AdvanceApproval') || (record.get('recordTypeId') === 'RecordType_RequiredNotification'); 

        if (isRecordNotified) {
            if ((getApproverGroupId === 'EngagementQualityReviewer') || (getApproverGroupId === 'RegionalProfessionalPractice')|| (getApproverGroupId === 'SubCountryProfessionalPractice')||(getApproverGroupId === 'CountryProfessionalPractice') || (getApproverGroupId === 'RequiredNotification') || (getApproverGroupId === 'AdvanceApprover')) {
                this.ui.approverBox.addClass('approverBackground')
            }
        }
        if (record.get('recordTypeId') === 'RecordType_RequiredNotification') {
            getApproverGroupId === 'CountryProfessionalPractice' && this.ui.group.closest('.approver-box').parent().addClass('validation-wrap-cpp');
            getApproverGroupId === 'RegionalProfessionalPractice' && this.ui.group.closest('.approver-box').parent().addClass('validation-wrap-rpp');
            getApproverGroupId === 'RequiredNotification' && this.ui.group.closest('.approver-box').parent().addClass('validation-wrap-rn');
        }
        if (first) {
            if((group.id == 'CountryProfessionalPractice' || group.id == 'RegionalProfessionalPractice' || group.id == 'SubCountryProfessionalPractice') && record.get('recordTypeId') === 'RecordType_AdvanceApproval') {
                var approverText = Labels['ApproverGroup_' + group.id] ;
                this.ui.group.html(approverText);   
                this.ui.requiredAA.text(Labels.RequiredText);
            }
            else{
            this.ui.group.html(Labels['ApproverGroup_' + group.id]);
            }
            this.ui.minus.parent().remove();
        }else {
            this.ui.group.remove();
            this.ui.plus.parent().remove();
            this.ui.rankLabel.remove();
            if (!me && !model.get('approval') && order <= group.get('order')) {
                this.ui.minus.parent().removeClass('hidden');
            } else if (disable) {
                this.ui.minus.parent().remove();
            }
        } // If this is not the first approver in the group then don't show the group label.

        if (record.get('assignedTo') === this.model.get('upn')) {
            this.ui.minus.parent().remove();
        }// If this is the current approver, don't show '-'

        if (group.get('lookup')) {
            var picklist = null;

            if (!complete && !disable && group.get('picklist')) {
                picklist = new Entities.Users();
                picklist.comparator = 'givenName';
                picklist.fetch({
                    filter: { roles: { $elemMatch: { geographyId: model.get('geographyId'), roleId: group.get('roleId') } }, active: true },
                    select: { active:1, displayName: 1, email: 1, geography: 1, givenName: 1, gpn: 1, id:1, mailNickname: 1, modifiedBy: 1, modifiedOn: 1, upn: 1,
                        physicalDeliveryOfficeName: 1, givenName: 1, roles: { $elemMatch: { geographyId: model.get('geographyId'), roleId: group.get('roleId') }}}
                });
            }
            UserLookup.show({
                region: this.getRegion('user'),
                user: model,
                collection: picklist
            });
        } // If lookup or picklist is required.

        if (!first || !group.get('multiple') || order > group.get('order')) {
            this.ui.plus.parent().remove();
        } // If multiple approvers are not needed.

        if (model.get('approval')) {
            //var dateString = new Date(model.get('approval')).format();
            var dateString = new Date(model.get('approval').split("T")[0]).toUTCString().split("00:00:00")[0].split(' ').slice(1).join(' '); //AMS
            var ampmTime = DateTimeUtil.convertToAmPm(this.model.get('approval'), 'UTC');
            this.ui.approval.html(dateString + ', '+ ampmTime).parent().removeClass('hidden');
            if (model.get("approverGroupId") === 'TeamMember') {
                this.ui.comment.addClass('hidden');
            } else {
                this.ui.comment.addClass(model.get('comments') ? 'fa fa-comment' : 'fa fa-comment-o');
            }
            if (model.get('comments')) {
                this.ui.printComment.removeClass('hidden');
            }
            Behaviors.tooltip(this.$('#comment'));
            this.ui.recusal.removeClass(model.get('recusal') ? 'hidden' : '');
            this.ui.recusal.attr('data-tooltip-title', Labels['Recusal_Hover_' + record.get('countryId')] || Labels['Recusal_Hover']);
            Behaviors.tooltip(this.$('#recusal'));
            this.ui.recusalText.html(Labels['Recusal_' + record.get('countryId')] || Labels['Recusal']);
            this.ui.independence.removeClass(model.get('independence') ? 'hidden' : '');
            Behaviors.tooltip(this.$('#independence'));
        } // If approval is provided.

        if (model.get('acknowledgeDate')) {
            //var dateString = new Date(model.get('acknowledgeDate')).format();
            var dateString = new Date(model.get('acknowledgeDate').split("T")[0]).toUTCString().split("00:00:00")[0].split(' ').slice(1).join(' '); //AMS
            var ampmTime = DateTimeUtil.convertToAmPm(this.model.get('acknowledgeDate'), 'UTC');
            this.ui.acknowledgedate.html(dateString + ', '+ ampmTime).parent().removeClass('hidden');
        }
        
        if (group.get('rank')) {
            var approver = new Entities.Approvers(this.collection.reject({ upn: '' })).find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
            var enumeration = new Entities.Enumerations(_.filter(Resources.Enumeration, (disable || complete) ? { type: group.id + 'Type' } : { type: group.id + 'Type', active: true }));
            var rankLabel = Labels['ApproverGroup_' + group.id + '_RankLabel'];
            this.ui.rankLabel.html(rankLabel);
            this.ui.rank.removeClass('hidden').addClass('col-md-3');
            Dropdown.show({
                collection: new Entities.Enumerations(_.any(this.collection.reject({ upn: '' }), { approverGroupId: group.id }) && approver && approver.get('rank') && !model.get('approval') && group.get('orderByRank') ? ranks(approver, enumeration) : enumeration.models),
                region: this.getRegion('rank'),
                resourceKeyAttribute: 'id',
                selection: this.model.get('rank') || -1,
                tooltip: true,
                onSelectionChanged: function (rank) {
                    model.set('rank', rank.id);
                    if (group.get('orderByRank')) {
                        model.set('order', group.get('order') * Offset + (rank.get('order') || Offset - 1));
                    }
                }
            });
        } // If rank is required.

        if (disable) {
            this.$('input,select').prop('disabled', 'disabled');
        } // If this record is assigned to self or is already approved or was not approved at a lower level because it was not required e.g. Team-Members.

        if (me) {
            this.$('input,select').addClass('record-approval-inprogress');
        } // If this is the current approver on the record.

        if (complete) {
            this.ui.minus.parent().remove();
            this.ui.plus.parent().remove();
        } // Record completed remove plus and minus actions.

        // Hide and disabling the clear option for approvers section
        if(group.get('rank')) {
            this.ui.clearRank.removeClass('hidden');
            if(disable) {    
                this.ui.clearRank.addClass('disabled');
            } else {
                this.ui.clearRank.removeClass('disabled');
            }
        } else {
            this.ui.clearRank.addClass('hidden');
        }
    },
    onAfterAuthorize: function () {
        var groups = this.options.groups;
        var record = this.options.record;
        var model = this.model;
        var order = record.get('statusTypeId') === Lookups.StatusType.ReviewApproval ? groups.get(record.get('approverGroupId')).get('order') : -1;
        var group = groups.get(model.get('approverGroupId'));
        var me = (record.get('assignedTo') !== '' && (model.get('upn') === record.get('assignedTo'))) && model.get('approverGroupId') === record.get('approverGroupId');
        var disable = (me || model.get('approval') || (!model.get('approval') && order > group.get('order')));

        if (disable) {
            this.$('input,select').prop('disabled', 'disabled');
        } // If this record is assigned to self or is already approved or was not approved at a lower level because it was not required e.g. Team-Members.
    },
    removeRNValidation: function() {
        var recordTypeId = this.options.record.get('recordTypeId');
        var approverId = this.model.get('approverGroupId');
        var roles = /TeamMember|EngagementQualityReviewer|CountryProfessionalPractice|RegionalProfessionalPractice|SubCountryProfessionalPractice|RequiredNotification/;
        return approverId.match(roles) &&  recordTypeId == "RecordType_RequiredNotification";
    },
    add: function () {
        var group = this.options.groups.get(this.model.get('approverGroupId'));
        var approvers = new Entities.Approvers(this.collection.where({ approverGroupId: group.id }));

        this.removeRNValidation() && $('.validation-wrap-main').removeClass('required').find('~ .required-errmsg').remove();
        $('.validation-wrap-main').removeAttr('class'); 
        // The above change is to remove the wrapper div class when new approver field is added. This will prevent displaying newly added approver field inside validation error border.
        this.collection.add(new Entities.Approver({
            id: _.now() + '',
            approverGroupId: group.id,
            geographyId: approvers.first().get('geographyId'),
            approvalNotRequired: group.get('approvalNotRequired') ? true : false,
            order: group.get('rank') && group.get('orderByRank') ? (group.get('order') * Offset) + (Offset - 1) : approvers.max('order').get('order') + 1,
            recusal: group.get('recusal') ? false : '',
            independence: group.get('independence') ? false : ''
        }));
    },
    remove: function () {
        this.collection.remove(this.model);
    }
});

var HeaderView = Marionette.View.extend({

    behaviors: [{ behaviorClass: Behaviors.Tooltip }],
    template: '#recordApproverHeader',
    ui: {
        header: '#header',
        icon: '#notificationIcon',
        headerApprover: '#headerApprover',

    },
    onRender: function () {
        var groups = this.options.groups;
        var group = groups.get(this.model.get('approverGroupId'));
        var headerText = Labels['ApproverGroup_' + group.id];
        var record = this.options.record;
        group.id === '_TOBENOTIFIED_HEADER' || '_ADVANCEAPPROVER_HEADER' ? this.ui.icon.removeClass('hidden') : this.ui.icon.addClass('hidden');

        this.ui.header.text(headerText);

        if(group.id === '_TEAMMEMBER_HEADER'){
            this.ui.header.closest('span').removeClass('approver-hdr-margin');
        }

        if (record.get('recordTypeId') === "RecordType_AdvanceApproval") {
            this.ui.header[0].innerText === Labels.ApproverGroup__TEAMMEMBER_HEADER ? this.ui.icon.addClass('hidden') : this.ui.icon.removeClass('hidden');
            this.ui.headerApprover.addClass('approverHighlight');
        }

        if (record.get('recordTypeId') === "RecordType_RequiredNotification") {
            this.ui.header.closest('span').removeClass('approver-hdr-margin');
            this.ui.icon.text(Labels.NotificationIconText);
            this.ui.header[0].innerText === Labels.ApproverGroup__TEAMMEMBER_HEADER ? this.ui.icon.addClass('hidden') : this.ui.icon.removeClass('hidden');
            this.ui.headerApprover.addClass('approverHighlight');
        }
    }
});

var CollectionView = Marionette.CollectionView.extend({
    childView: function (model) {

        return model.get("approverGroupId").indexOf("_HEADER") > -1 ? HeaderView : View;
    },
    childViewOptions: function () {
        return {
            collection: this.collection,
            groups: this.options.groups,
            record: this.options.record
        };
    }
});

var configure = function (options) {

    var groups = options.groups;

    if (options.approvers.length == 0) {
        var record = options.record;

        groups.each(function (group, index) {
            if (group.get('visible')) {
                var role = Roles.get(group.get('roleId'));
                var count = group.get('geographyTypePath') ? group.get('geographyTypePath').slice(1, -1).split('/').length : 0;

                options.approvers.add(new Entities.Approver({
                    id: _.now() + '' + index,
                    approverGroupId: group.id,
                    geographyId: !role ? '' : role.get('geographyRequired') ? '/' + _.take(record.get('geographyId').slice(1, -1).split('/'), count).join('/') + '/' : '//',
                    order: group.get('order') * Offset,
                    approvalNotRequired: group.get('approvalNotRequired') ? true : false,
                    recusal: group.get('recusal') ? false : '',
                    independence: group.get('independence') ? false : ''
                }));
            }
        });
    }
    options.approvers.on('change:upn', function (approver) {
        if ((approver.get('approverGroupId') === 'CountryProfessionalPractice' || approver.get('approverGroupId') === 'RegionalProfessionalPractice') && options.record.get('recordTypeId') === 'RecordType_RequiredNotification' && approver.get('upn')) {
            $('.validation-wrap-main').removeClass('required').find('~ .required-errmsg').remove();
        }
        if (options.approvers.filter({ upn: approver.get('upn') }).length > 1) {
            if (approver.get('upn') !== '') {
                approver.set({
                    displayName: '',
                    email: '',
                    givenName: '',
                    upn: ''
                });
                DialogWarning.show({
                    message: Labels.MSG008
                });
            }
        }
    });
};

module.exports.start = function (options) {
    var region = options.region;

    configure(options);
    region.show(new CollectionView(_.extend({}, options, {
        collection: options.approvers
    })));
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordApprover.js